import { publicRequest } from "./publicInviteApi.js";

/**
 * P156 frontend for P139A's public Employer Invite Card endpoints
 * (GET /api/public/employer-invite-card, POST .../apply).
 *
 * Reuses publicInviteApi's request seam rather than the shared apiClient, for
 * exactly the reason that module documents: apiRequest() attaches an
 * Authorization header whenever a session token happens to exist in the tab -
 * which it very often does here, because the Agent previews their own employer
 * link while still signed in to the backoffice. These routes are
 * unauthenticated by design.
 *
 * A separate module from the worker calls even so: the owner's rule is that
 * the two sides never mix, and one shared "invite" module is how an employer
 * link would eventually resolve a worker form.
 */
export function getPublicEmployerInviteCard(inviteCode, options) {
  return publicRequest(`/public/employer-invite-card?invite=${encodeURIComponent(inviteCode)}`, {
    ...options,
    method: "GET",
  });
}

export function submitEmployerApplication(payload, options) {
  return publicRequest("/public/employer-invite-card/apply", {
    ...options,
    method: "POST",
    body: JSON.stringify(payload),
  });
}
